<template>
  <div class="vue-wrapper-sidebar" style="display:flex; flex-direction:column; height:100%;">
    <div class="modal-window-header">
      <div class="modal-window-heading">
        <h3>{{ currentIndex + 1 }} / {{ images.length }}</h3>
      </div>
      <a href="javascript:;" @click="closeModal()" class="modal-window-close-button modal-window-sidebar-close-button">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </div>

    <div style="height:calc(100vh - 4rem - 130px); display:flex; align-items:center; justify-content:center; background:#111; position:relative; overflow:hidden;">
      <a v-if="images.length > 1" href="javascript:;" @click="prev()" style="position:absolute; left:0; top:0; bottom:0; width:48px; display:flex; align-items:center; justify-content:center; z-index:2; background:rgba(0,0,0,0.3);">
        <svg class="icon" viewBox="0 0 24 24" width="28px" height="28px" style="fill:#fff;">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M15.71,6.71,10.41,12l5.3,5.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0l-6-6a1,1,0,0,1,0-1.42l6-6a1,1,0,1,1,1.42,1.42Z"/>
        </svg>
      </a>

      <img
        :src="currentImageUrl"
        alt="Bilde"
        style="max-width:100%; max-height:100%; object-fit:contain; display:block;"
      />

      <a v-if="images.length > 1" href="javascript:;" @click="next()" style="position:absolute; right:0; top:0; bottom:0; width:48px; display:flex; align-items:center; justify-content:center; z-index:2; background:rgba(0,0,0,0.3);">
        <svg class="icon" viewBox="0 0 24 24" width="28px" height="28px" style="fill:#fff;">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M8.29,17.29,13.59,12,8.29,6.71A1,1,0,0,1,9.71,5.29l6,6a1,1,0,0,1,0,1.42l-6,6a1,1,0,0,1-1.42,0A1,1,0,0,1,8.29,17.29Z"/>
        </svg>
      </a>
    </div>

    <div v-if="images.length > 1" style="display:flex; justify-content:center; gap:6px; padding:10px; background:#111;">
      <a
        v-for="(img, idx) in images"
        :key="img.id"
        href="javascript:;"
        @click="currentIndex = idx"
        style="width:10px; height:10px; border-radius:50%; display:inline-block;"
        :style="{ background: idx === currentIndex ? '#fff' : 'rgba(255,255,255,0.35)' }"
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotatImageLightboxModal',
  props: {
    images: {
      type: Array,
      required: true
    },
    startIndex: {
      type: Number,
      default: 0
    },
    apiBaseUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentIndex: this.startIndex
    }
  },
  computed: {
    currentImageUrl () {
      return this.apiBaseUrl + '/' + this.images[this.currentIndex].ImagePath
    }
  },
  methods: {
    prev () {
      this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.images.length - 1
    },
    next () {
      this.currentIndex = this.currentIndex < this.images.length - 1 ? this.currentIndex + 1 : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/NotatImageLightboxModal.vue